export default {
  spacing: 1.1,
  gutters: "1.25rem",
}
